import { render, staticRenderFns } from "./RouterLink.vue?vue&type=template&id=51cebfee&"
import script from "./RouterLink.vue?vue&type=script&lang=ts&"
export * from "./RouterLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports